import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import PageNotFound from '../views/PageNotFound'
import DetailAide from '../views/DetailAide'
import ReportError from '../views/ReportError'
import DataCenter from '../views/DataCenter'
import MentionsLegales from '../views/MentionsLegales'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/detail-aide/:idAide',
    name: 'DetailAide',
    component: DetailAide,
    props: true
  },
  {
    path: '/signaler-erreur/:idAide',
    name: 'reportError',
    component: ReportError
  },
  {
    path: '/mentions-legales',
    name: 'mentionsLegales',
    component: MentionsLegales
  },
  {
    path: '/vos-donnees-et-vos-droits',
    name: 'DataCenter',
    component: DataCenter
  },
  {
    path: '*',
    name: '404',
    component: PageNotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    window.scrollTo(0, 0)
  }
})

export default router
